import React from 'react';

const FormTitle = ({ children, styles = {} }) => {
  return <h2 className={styles.formTitle || 'form--title'}>{children}</h2>;
};

export default FormTitle;
